import {
  GET_PROMOTIONS_REQUEST,
  GET_PROMOTIONS_RESPONSE,
  GET_PROMOTIONS_ERROR,
} from 'actions/promotions';

const initialState = {
  promotions: [],
  isLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PROMOTIONS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case GET_PROMOTIONS_RESPONSE:
      return {
        ...state,
        promotions: action.response.promotions,
        isLoading: false,
      };
    case GET_PROMOTIONS_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export const selectPromotions = state => state.promotions.promotions;
export const selectPromotionsLoading = state => state.promotions.isLoading;

export const selectFirstPromotionWithHeroImage = state => {
  const promotions = selectPromotions(state);

  return promotions?.find(promotion => Boolean(promotion.heroImage));
};

export const selectPromotionById = (state, promotionId) => {
  const promotions = selectPromotions(state);

  return promotions?.find(promotion => promotion.id === promotionId);
};
